import { render } from "./segmenta-cookieHandler.vue?vue&type=template&id=7f822c97"
import script from "./segmenta-cookieHandler.vue?vue&type=script&lang=js"
export * from "./segmenta-cookieHandler.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__